import axios from "axios";
import Vue from "vue";
export const state = {
  grades: [],
  save_status: false,
};
export const getters = {
  AllGrades: (state) => state.grades.data,
  SaveStatus: (state) => state.save_status,
};

export const mutations = {
  SET_GRADES(state, newValue) {
    state.grades = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  //add grades
  addGrade({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("grades", payload)
      .then((response) => {
        commit("SET_GRADES", response.data);
        dispatch("fetchGrades", response.data.msg);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
      });
  },
  // Edit Grade
  editGrade({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`grades/${payload.id}`, payload)
      .then((response) => {
        dispatch("fetchGrades", response.data.msg);
        commit("SET_GRADES", response.data);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
      });
  },
  // Delete Grade
  deleteGrade({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`grades/${payload.id}`)
      .then((response) => {
        dispatch("fetchGrades", response.data.msg);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
      });
  },
  //fetching all grades
  fetchGrades({ commit }, msg) {
    axios.get("grades").then((grades) => {
      commit("SET_GRADES", grades.data);
      if (msg) {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: msg,
        };
        commit("pushNotification", message);
      }
    });
  },
};
